import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../../system/components/Loading";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../system/containers/Aux";
import Toolbar from "./components/Toolbar";
import PageHeader from "../../system/components/PageHeader";
import { WrappedTable, filterString } from "../../system/containers/Table";

import { actionCreators } from "../../store/deals";

const CheckboxTable = checkboxHOC(ReactTable);
const columns = [
  {
    accessor: "id",
    Header: "Deal ID",
    filterMethod: filterString,
    Cell: props => <a href={"/deals/edit/" + props.original.id}>{props.value}</a>
  },
  {
    accessor: "name",
    Header: "Deal Name",
    filterMethod: filterString,
    Cell: props => <a href={"/deals/edit/" + props.original.id}>{props.value}</a>
  },
  {
    accessor: "created_at",
    Header: "Created",
    filterable: false,
    Cell: props => moment(props.value).format("llll")
  },
  {
    accessor: null,
    Header: null,
    filterable: false,
    Cell: props => (
      <div className={"d-flex justify-content-center"}>
        <Link className={"mr-3"} to={"/deals/edit/" + props.original.id}>
          <Button outline size="sm">
            Edit
          </Button>
        </Link>
        <a className={"ml-3"} href={`http://viva-holidays.co.uk/holiday/${props.original.slug}/${props.original.id}/${props.original.deal_status && props.original.deal_status.name.toLowerCase() === "preview" ? 'preview' : ''}`} target="_blank">
          <Button size="sm" color={"primary"}>
            View
          </Button>
        </a>
      </div>
    )
  }
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: []
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected any entries");
    }
    const result = window.confirm(
      "Are you sure you want to remove these entries?"
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Deals" />
        <Toolbar
          permissions={permissions}
          createLink={"/deals/create"}
          total={data.length}
          handleDelete={() => this.remove()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "60px" }}
        >
          <CheckboxTable
            ref={r => (this.checkboxTable = r)}
            data={data}
            keyField="id"
            showPaginationBottom
            filterable
            columns={columns}
            loading={data.loading}
            defaultPageSize={20}
            style={{
              height: "100vh"
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.deals.list,
    loading: store.deals.loading
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/Deals/List.jsx